{
  "version": 1,
  "asset_id": "a88aa4db-28d6-4527-a714-3fd327708630",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/a88aa4db-28d6-4527-a714-3fd327708630/hero-accounting.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/a88aa4db-28d6-4527-a714-3fd327708630/hero-accounting.jpg",
  "original_filename": "hero-accounting.jpg",
  "size": 112295,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:37:53Z"
}
